// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escalations-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
}

/* Header Actions */
.header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 15px;
}

/* WebSocket Connection Indicator */
.websocket-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 500;
}

.websocket-indicator.connected {
  color: #4CAF50;
  background: rgba(76, 175, 80, 0.1);
}

.websocket-indicator.disconnected {
  color: #F44336;
  background: rgba(244, 67, 54, 0.1);
}

.websocket-indicator i {
  font-size: 16px;
}

.websocket-indicator.connected i {
  animation: pulse 2s infinite;
}

/* Refresh Button */
.refresh-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.refresh-button:hover:not(:disabled) {
  background: #5568d3;
  transform: translateY(-1px);
}

.refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.refresh-button i.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Notification Toast */
.notification-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px 20px;
  min-width: 300px;
  max-width: 400px;
  z-index: 10000;
  cursor: pointer;
  animation: slideIn 0.3s ease-out;
  border-left: 4px solid #667eea;
}

.notification-toast.sla_breach {
  border-left-color: #F44336;
}

.notification-toast.sla_warning {
  border-left-color: #FF9800;
}

.notification-toast.new_escalation {
  border-left-color: #4CAF50;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.notification-content i {
  font-size: 20px;
  color: #667eea;
}

.notification-toast.sla_breach .notification-content i {
  color: #F44336;
}

.notification-toast.sla_warning .notification-content i {
  color: #FF9800;
}

.notification-toast.new_escalation .notification-content i {
  color: #4CAF50;
}

.notification-content span {
  flex: 1 1;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
}

.notification-close {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 0;
  margin-left: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  transition: color 0.2s ease;
}

.notification-close:hover {
  color: #333;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 15px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.stat-icon.pending {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
}

.stat-icon.resolved {
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
}

.stat-icon.week {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
}

.stat-icon.sla {
  background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
}

.stat-icon.time {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
}

.stat-icon.compliance {
  background: linear-gradient(135deg, #00BCD4 0%, #0097A7 100%);
}

.stat-content h3 {
  margin: 0 0 5px 0;
  font-size: 12px;
  text-transform: uppercase;
  color: #666;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.stat-value.warning {
  color: #F44336;
}

/* Filters Section */
.filters-section {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
}

.filter-group label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.filter-group select {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.filter-group select:hover {
  border-color: #667eea;
}

.filter-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Escalations List */
.escalations-list-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.escalations-table {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.escalation-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  transition: all 0.2s ease;
  background: #fafafa;
}

.escalation-card:hover {
  border-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  background: white;
}

.escalation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 10px;
}

.escalation-id {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.badge {
  background: #667eea;
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-pending {
  background: #FFF3E0;
  color: #E65100;
}

.status-collecting {
  background: #E3F2FD;
  color: #1565C0;
}

.status-awaiting {
  background: #FFF9C4;
  color: #F57F17;
}

.status-progress {
  background: #E1BEE7;
  color: #6A1B9A;
}

.status-resolved {
  background: #C8E6C9;
  color: #2E7D32;
}

.status-cancelled {
  background: #FFCDD2;
  color: #C62828;
}

.priority-badge {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.priority-urgent {
  background: #FFEBEE;
  color: #C62828;
  border: 1px solid #C62828;
}

.priority-high {
  background: #FFF3E0;
  color: #E65100;
  border: 1px solid #E65100;
}

.priority-normal {
  background: #E8F5E9;
  color: #2E7D32;
  border: 1px solid #2E7D32;
}

.priority-low {
  background: #F3E5F5;
  color: #7B1FA2;
  border: 1px solid #7B1FA2;
}

.escalation-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-view,
.btn-assign,
.btn-resolve {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-view {
  background: #667eea;
  color: white;
}

.btn-view:hover {
  background: #5568d3;
}

.btn-assign {
  background: #FF9800;
  color: white;
}

.btn-assign:hover {
  background: #F57C00;
}

.btn-resolve {
  background: #4CAF50;
  color: white;
}

.btn-resolve:hover {
  background: #388E3C;
}

.escalation-body {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
}

.escalation-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.info-label {
  font-weight: 600;
  color: #666;
  min-width: 100px;
  font-size: 14px;
}

.info-value {
  color: #333;
  font-size: 14px;
  flex: 1 1;
}

.info-value a {
  color: #667eea;
  text-decoration: none;
}

.info-value a:hover {
  text-decoration: underline;
}

.trigger-message {
  font-style: italic;
  color: #666;
}

.escalation-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  min-width: 200px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;
}

.meta-item i {
  font-size: 14px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-state p {
  font-size: 16px;
}

/* Loading */
.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.pagination button {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pagination button:hover:not(:disabled) {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  color: #666;
  font-size: 14px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-content.small {
  max-width: 500px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f0f0f0;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #667eea;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.detail-item.full-width {
  grid-column: 1 / -1;
}

.detail-item label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-item span {
  font-size: 14px;
  color: #333;
}

.detail-item span a {
  color: #667eea;
  text-decoration: none;
}

.detail-item span a:hover {
  text-decoration: underline;
}

.message-box {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #667eea;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.detail-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

/* Form Elements */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-cancel,
.btn-primary {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel {
  background: #f0f0f0;
  color: #333;
}

.btn-cancel:hover {
  background: #e0e0e0;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5568d3;
}

/* Title with back button */
.title-with-back {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    margin-bottom: 20px;
}

.title-with-back h1 {
    flex: 1 1;
    margin: 0;
}

.back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #666;
}

.back-button:hover {
    background: #f0f0f0;
    border-color: #007bff;
    color: #007bff;
}

.back-button i {
    font-size: 18px;
}

/* Responsive */
@media (max-width: 768px) {
  .escalations-page {
    padding: 10px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .escalation-body {
    grid-template-columns: 1fr;
  }

  .escalation-meta {
    align-items: flex-start;
    min-width: auto;
  }

  .escalation-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .escalation-actions {
    width: 100%;
  }

  .escalation-actions button {
    flex: 1 1;
  }

  .modal-content {
    margin: 10px;
    max-height: calc(100vh - 20px);
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Escalations.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAO;AACT;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".escalations-page {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n  position: relative;\n}\n\n/* Header Actions */\n.header-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n/* WebSocket Connection Indicator */\n.websocket-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-weight: 500;\n}\n\n.websocket-indicator.connected {\n  color: #4CAF50;\n  background: rgba(76, 175, 80, 0.1);\n}\n\n.websocket-indicator.disconnected {\n  color: #F44336;\n  background: rgba(244, 67, 54, 0.1);\n}\n\n.websocket-indicator i {\n  font-size: 16px;\n}\n\n.websocket-indicator.connected i {\n  animation: pulse 2s infinite;\n}\n\n/* Refresh Button */\n.refresh-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.refresh-button:hover:not(:disabled) {\n  background: #5568d3;\n  transform: translateY(-1px);\n}\n\n.refresh-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.refresh-button i.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Notification Toast */\n.notification-toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 16px 20px;\n  min-width: 300px;\n  max-width: 400px;\n  z-index: 10000;\n  cursor: pointer;\n  animation: slideIn 0.3s ease-out;\n  border-left: 4px solid #667eea;\n}\n\n.notification-toast.sla_breach {\n  border-left-color: #F44336;\n}\n\n.notification-toast.sla_warning {\n  border-left-color: #FF9800;\n}\n\n.notification-toast.new_escalation {\n  border-left-color: #4CAF50;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.notification-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.notification-content i {\n  font-size: 20px;\n  color: #667eea;\n}\n\n.notification-toast.sla_breach .notification-content i {\n  color: #F44336;\n}\n\n.notification-toast.sla_warning .notification-content i {\n  color: #FF9800;\n}\n\n.notification-toast.new_escalation .notification-content i {\n  color: #4CAF50;\n}\n\n.notification-content span {\n  flex: 1;\n  font-size: 14px;\n  color: #333;\n  line-height: 1.4;\n}\n\n.notification-close {\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 12px;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n\n.notification-close:hover {\n  color: #333;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  color: white;\n}\n\n.stat-icon.pending {\n  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);\n}\n\n.stat-icon.resolved {\n  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);\n}\n\n.stat-icon.week {\n  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);\n}\n\n.stat-icon.sla {\n  background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);\n}\n\n.stat-icon.time {\n  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);\n}\n\n.stat-icon.compliance {\n  background: linear-gradient(135deg, #00BCD4 0%, #0097A7 100%);\n}\n\n.stat-content h3 {\n  margin: 0 0 5px 0;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #666;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  font-size: 28px;\n  font-weight: bold;\n  color: #333;\n}\n\n.stat-value.warning {\n  color: #F44336;\n}\n\n/* Filters Section */\n.filters-section {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 200px;\n}\n\n.filter-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.filter-group select {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.filter-group select:hover {\n  border-color: #667eea;\n}\n\n.filter-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* Escalations List */\n.escalations-list-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.escalations-table {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.escalation-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 20px;\n  transition: all 0.2s ease;\n  background: #fafafa;\n}\n\n.escalation-card:hover {\n  border-color: #667eea;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);\n  background: white;\n}\n\n.escalation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.escalation-id {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.badge {\n  background: #667eea;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-badge {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-pending {\n  background: #FFF3E0;\n  color: #E65100;\n}\n\n.status-collecting {\n  background: #E3F2FD;\n  color: #1565C0;\n}\n\n.status-awaiting {\n  background: #FFF9C4;\n  color: #F57F17;\n}\n\n.status-progress {\n  background: #E1BEE7;\n  color: #6A1B9A;\n}\n\n.status-resolved {\n  background: #C8E6C9;\n  color: #2E7D32;\n}\n\n.status-cancelled {\n  background: #FFCDD2;\n  color: #C62828;\n}\n\n.priority-badge {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.priority-urgent {\n  background: #FFEBEE;\n  color: #C62828;\n  border: 1px solid #C62828;\n}\n\n.priority-high {\n  background: #FFF3E0;\n  color: #E65100;\n  border: 1px solid #E65100;\n}\n\n.priority-normal {\n  background: #E8F5E9;\n  color: #2E7D32;\n  border: 1px solid #2E7D32;\n}\n\n.priority-low {\n  background: #F3E5F5;\n  color: #7B1FA2;\n  border: 1px solid #7B1FA2;\n}\n\n.escalation-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.btn-view,\n.btn-assign,\n.btn-resolve {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-view {\n  background: #667eea;\n  color: white;\n}\n\n.btn-view:hover {\n  background: #5568d3;\n}\n\n.btn-assign {\n  background: #FF9800;\n  color: white;\n}\n\n.btn-assign:hover {\n  background: #F57C00;\n}\n\n.btn-resolve {\n  background: #4CAF50;\n  color: white;\n}\n\n.btn-resolve:hover {\n  background: #388E3C;\n}\n\n.escalation-body {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 20px;\n}\n\n.escalation-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.info-row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #666;\n  min-width: 100px;\n  font-size: 14px;\n}\n\n.info-value {\n  color: #333;\n  font-size: 14px;\n  flex: 1;\n}\n\n.info-value a {\n  color: #667eea;\n  text-decoration: none;\n}\n\n.info-value a:hover {\n  text-decoration: underline;\n}\n\n.trigger-message {\n  font-style: italic;\n  color: #666;\n}\n\n.escalation-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-end;\n  min-width: 200px;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #666;\n}\n\n.meta-item i {\n  font-size: 14px;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #999;\n}\n\n.empty-state i {\n  font-size: 64px;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n\n.empty-state p {\n  font-size: 16px;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pagination button {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: #667eea;\n  color: white;\n  border-color: #667eea;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  color: #666;\n  font-size: 14px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modal-content.small {\n  max-width: 500px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #333;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.detail-section {\n  margin-bottom: 30px;\n}\n\n.detail-section h3 {\n  margin: 0 0 15px 0;\n  font-size: 16px;\n  color: #667eea;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.detail-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.detail-item label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-item span {\n  font-size: 14px;\n  color: #333;\n}\n\n.detail-item span a {\n  color: #667eea;\n  text-decoration: none;\n}\n\n.detail-item span a:hover {\n  text-decoration: underline;\n}\n\n.message-box {\n  background: #f5f5f5;\n  padding: 15px;\n  border-radius: 8px;\n  border-left: 4px solid #667eea;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.detail-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Form Elements */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.btn-cancel,\n.btn-primary {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-cancel {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.btn-cancel:hover {\n  background: #e0e0e0;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #5568d3;\n}\n\n/* Title with back button */\n.title-with-back {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.title-with-back h1 {\n    flex: 1;\n    margin: 0;\n}\n\n.back-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border: 1px solid #ddd;\n    background: white;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: #666;\n}\n\n.back-button:hover {\n    background: #f0f0f0;\n    border-color: #007bff;\n    color: #007bff;\n}\n\n.back-button i {\n    font-size: 18px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .escalations-page {\n    padding: 10px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .escalation-body {\n    grid-template-columns: 1fr;\n  }\n\n  .escalation-meta {\n    align-items: flex-start;\n    min-width: auto;\n  }\n\n  .escalation-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .escalation-actions {\n    width: 100%;\n  }\n\n  .escalation-actions button {\n    flex: 1;\n  }\n\n  .modal-content {\n    margin: 10px;\n    max-height: calc(100vh - 20px);\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
